module.exports = __webpack_public_path__ + "e0cbb9d60373d295c3c0b3f50c91c9bc.svg";